import styled from 'styled-components';

const DEFAULT_PARAGRAPH_COLOR = '#636363';

export const ParagraphAgreementRequirement = styled.p`
  color: ${({ theme }) => (theme.backgroundMode === 'darkMode' ? '#ffffff' : DEFAULT_PARAGRAPH_COLOR)};
`;
